// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2384":"875ddfb1","4158":"3daf6486","8173":"1275ec78","9321":"1275ec78","9598":"f8270be1"}[chunkId] + ".chunk.css";
};